export function removeFirstVisibleCharacterInHtml(text: string): string {
    let isInHtmlTag = false;
    let hasRemovedCharacter = false;

    return text.split('').reduce((acc: string, char: string) => {
        if (char === '<') {
            isInHtmlTag = true;
        }

        if (!isInHtmlTag && !hasRemovedCharacter) {
            hasRemovedCharacter = true;
        } else {
            // eslint-disable-next-line no-param-reassign
            acc += char;
        }

        if (char === '>') {
            isInHtmlTag = false;
        }

        return acc;
    }, '');
}
